import { Container, Typography } from '@mui/material';
import { useAuth } from '@contexts/AuthContext';
import { useProId } from '@contexts/ProIdContext';
import { useNavigate } from 'react-router-dom';
import JobOfferTemplateForm from './forms/JobOfferTemplateForm';

const JobOfferTemplateAdd: React.FC = () => {
    const { user } = useAuth();
    const { selectedProId } = useProId();
    const navigate = useNavigate();

    const resolvedProId = selectedProId ?? user?.adminProId;

    if (!resolvedProId) {
        return (
            <Container>
                <Typography color="error">Impossible de déterminer le pro ID.</Typography>
            </Container>
        );
    }

    return (
        <JobOfferTemplateForm
            proId={resolvedProId}
            onSuccess={(result) => {
                if (result?.jobNumber) {
                    navigate(`/job-offer-templates/${result.jobNumber}/detail`);
                } else {
                    navigate('/job-offer-templates');
                }
            }}
        />
    );
};

export default JobOfferTemplateAdd;
